module.exports = __webpack_public_path__ + "img/resource-wx-active.3b3157c5.png";